import { ArticleModel } from '../models/ArticleModel';
import { normalizeCategories, normalizeCategory } from '../../category/normalizers/CategoryNormalizer';
import { normalizeAuthors } from '../../author/normalizers/AuthorNormalizer';
import { normalizeOrigin } from '../../origin/normalizers/OriginNormalizer';
import { normalizeMainMedia } from '../../mainMedia/normalizers/MainMediaNormalizer';
import { normalizeSeo } from '../../seo/normalizers/SeoNormalizer';
import { normalizeUrl } from '../../url/normalizers/UrlNormalizer';
import { ArticlePartialModel } from '../models/ArticlePartialModel';

export const normalizeArticle = (response: any): ArticleModel => {
    return {
        id: response?.id ? response.id : null,
        entityType: response?.entity_type ? response.entity_type : null,
        title: response?.title ? response.title : null,
        subtitle: response?.subtitle ? response.subtitle : null,
        strapline: response?.strapline ? response.strapline : null,
        footer: response?.footer ? response.footer : null,
        body: response && response.body ? response.body : [],
        publishedAt: response?.published_at ? response.published_at : null,
        publishedUntil: response?.published_until ? response.published_until : null,
        status: response?.status ? response.status : null,
        type: response?.type ? response.type : null,
        live: response?.live ? response.live : null,
        important: response?.important ? response.important : null,
        runAds: response?.run_ads ? response.run_ads : null,
        customAuthor: response?.custom_author ? response.custom_author : null,
        adultContent: response?.adult_content ? response.adult_content : null,
        sensitiveContent: response?.sensitive_content ? response.sensitive_content : null,
        category: response?.category ? normalizeCategory(response.category) : null,
        additionalCategories: normalizeCategories(response?.categories ?? null),
        mainMedia: normalizeMainMedia(response?.main_media ?? null),
        createdAt: response?.created_at ? response.created_at : null,
        updatedAt: response?.updated_at ? response.updated_at : null,
        urls: response?.urls ? normalizeUrl(response.urls) : null,
        seo: normalizeSeo(response?.seo ?? null),
        authors: normalizeAuthors(response?.authors ?? null),
        origin: normalizeOrigin(response?.origin ?? null),
    };
};

export const normalizePartialArticle = (response: any): ArticlePartialModel => {
    return {
        id: response?.id ? response.id : null,
        entityType: response?.entity_type ? response.entity_type : null,
        title: response?.title ? response.title : null,
        subtitle: response?.subtitle ? response.subtitle : null,
        strapline: response?.strapline ? response.strapline : null,
        publishedAt: response?.published_at ? response.published_at : null,
        publishedUntil: response?.published_until ? response.published_until : null,
        status: response?.status ? response.status : null,
        customAuthor: response?.custom_author ? response.custom_author : null,
        category: normalizeCategory(response?.category ?? null),
        mainMedia: normalizeMainMedia(response?.main_media ?? null),
        createdAt: response?.created_at ? response.created_at : null,
        updatedAt: response?.updated_at ? response.updated_at : null,
        authors: normalizeAuthors(response?.authors ?? null),
    };
};

export const normalizePartialArticles = (response: any[]) => {
    return response ? response.map((response) => normalizePartialArticle(response)) : [];
};

export const normalizeArticles = (response: any[]) => {
    return response ? response.map((response) => normalizeArticle(response)) : [];
};
